
























































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { FacetGroupFilter, FacetInfo, FacetFilter } from '@/models/Product';

@Component
export default class ProductFilter extends Vue {
    @Prop()
    protected productsCounter!: number;
    @Prop()
    protected facetInfo!: FacetInfo;
    @Prop()
    protected getLinkContentCall!: Function;
    protected showFilter: boolean = false;
    protected showFilters: boolean = false;
    protected url = new URL(location.href);
    constructor() {
        super();
    }

    private toggleFilter(e: any) {
        // console.log(e);
        const filter = e.currentTarget;

        if (!filter.classList.contains('open')) {
            this.closeFilters();
            filter.classList.add('open');
        } else if (
            filter.classList.contains('open') &&
            e.srcElement.classList.contains('toggle-arrow')
        ) {
            this.closeFilters();
        }
    }
    private getLinkContentClickEvent(link: string) {
        // console.log(link);
        this.getLinkContentCall(link);
    }

    private closeFilters() {
        const filters = document.querySelectorAll('.filter-item');
        filters.forEach((filter: any) => {
            filter.classList.remove('open');
        });
    }

    private activeOptions(options: FacetFilter[]) {
        return options.filter(row => row.Quantity > 0);
    }

    private facetGroupFiltersWithactiveOptions(
        facetGroupFilters: FacetGroupFilter[]
    ) {
        return facetGroupFilters.filter(
            row => this.activeOptions(row.Options).length > 1
        );
    }
}
